import React from 'react'
import { MdOutlineClose } from "react-icons/md";
import CustomDialog from '../../../components/CustomDialog';
import BeatLoader from "react-spinners/BeatLoader";

const override = {
    display: "block",
    margin: "15px auto",
    borderColor: "red",
};

export const ViewDetailsDialog = (props) => {
    const { open, setOpen, loading, detailsData, isMobile} = props;

    return (
        <CustomDialog open={open} extraStyle={{ overflowY: 'scroll', scrollbarWidth: 'thin', maxHeight: 500 }} width={500} isMobile={isMobile}>
            <MdOutlineClose style={{  position: 'absolute', top: 3, right: 3}} className='text-2xl cursor-pointer text-customInk hover:text-customAccentBlue dark:text-customWhite' onClick={() => setOpen(false)} />
          
            <div className='flex justify-center mx-auto'>
                {
                    loading ?
                        <BeatLoader
                            color={'#292E4C'}
                            loading={loading}
                            cssOverride={override}
                            size={18}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        /> :
                        <table className="w-full">
                            <thead className='border-b border-customTitleColor dark:border-customBorder border-dashed mb-3'>
                                <tr className='text-sm font-bold text-customSecondaryText dark:text-customMuted'>
                                    <th className='w-[5%] text-center'>
                                        <p>No</p>
                                    </th>
                                    <th className='w-[70%]'>
                                        <p>Choice</p>
                                    </th>
                                    <th className='w-[10%] text-center'>
                                        <p> Odds</p>
                                    </th>
                                    <th className='w-[15%] text-center'>
                                        <p> Bet</p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className='text-xs mx-auto font-semibold'>
                                {detailsData &&
                                    detailsData.map((v, i) =>
                                        <tr className='py-3 border-b border-customTitleColor text-center text-customInk dark:border-customBorder dark:text-customWhite' key={i}>
                                            <td className='w[5%]'>
                                                <p> {i + 1}</p>
                                            </td>
                                            <td className='w-[70%]'>
                                                <div className='flex flex-col'>
                                                    <span className='text-[0.675rem] text-customFontGreen'>
                                                        <p> {v.leagueName}</p>
                                                    </span>
                                                    <span className='text-[0.675rem] text-customInk dark:text-customWhite'>
                                                        <p>{v.isHome ? `${v.bettedTeam} VS ${v.oppositeTeamName}` : `${v.oppositeTeamName} VS ${v.bettedTeam}`}</p>
                                                    </span>
                                                    <span className='text-customFontVoilet'>
                                                        Result ({v.homeResult} - {v.awayResult})
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='w-[10%] text-center'>
                                                {v.overs || v.under ? v.goalOdd : v.bodyOdd}
                                            </td>
                                            <td className='w-[15%] text-center'>
                                                <p> {v.under ? 'Under' : v.overs ? 'Over' : v.bettedTeam}</p>
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                }
            </div>
        </CustomDialog>
    )
}


